import { range } from 'lodash';
import { Bones } from '@simplywallst/ui-core';

interface Props {
  row?: number;
  isMarketPage: boolean;
}

const RowSkeleton = ({ row = 1, isMarketPage }: Props) => (
  <>
    {range(row).map((i) => (
      <tr key={i} data-cy-id="market-mover-skeleton">
        <td>
          <span>
            <Bones minHeight={66} />
          </span>
        </td>
        <td>
          <span>
            <Bones minHeight={66} />
          </span>
        </td>
        <td>
          <span>
            <Bones minHeight={66} />
          </span>
        </td>
        <td>
          <span>
            <Bones minHeight={66} />
          </span>
        </td>
        <td>
          <span>
            <Bones minHeight={66} />
          </span>
        </td>
        {isMarketPage && (
          <td>
            <span>
              <Bones minHeight={66} />
            </span>
          </td>
        )}
      </tr>
    ))}
  </>
);

export default RowSkeleton;
